import _extends from "@babel/runtime/helpers/extends";
import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { InfoCircleIcon } from '@pattern-library/icon';
import MessagePopover from './MessagePopover';
const propTypes = {
  /**
   * Additional props to pass to the trigger button element
   */
  buttonProps: PropTypes.object,
  /**
   * Accessible label for the trigger button
   */
  buttonLabel: PropTypes.string,
  /**
   * Content for the message popover
   */
  messagePopoverContent: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  /**
   * DOM ID for the message popover component to accessibly associate its content with the form input
   */
  messagePopoverId: PropTypes.string.isRequired,
  /**
   * Additional props to pass to the message popover component
   */
  messagePopoverProps: PropTypes.object
};
const FormLabelPopover = _ref => {
  let {
    buttonLabel = 'More info',
    buttonProps = {},
    messagePopoverContent,
    messagePopoverId,
    messagePopoverProps = {}
  } = _ref;
  const triggerRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const handleTriggerClick = () => {
    setIsOpen(prevState => !prevState);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("button", _extends({
    type: "button",
    onClick: handleTriggerClick,
    className: "asc-form-label-popover-trigger",
    ref: triggerRef,
    "aria-label": buttonLabel,
    title: buttonLabel,
    "aria-haspopup": true,
    "aria-expanded": isOpen,
    "aria-controls": messagePopoverId
  }, buttonProps), /*#__PURE__*/React.createElement(InfoCircleIcon, {
    color: "brand-link",
    customSize: "14px"
  })), /*#__PURE__*/React.createElement(MessagePopover, _extends({
    id: messagePopoverId,
    target: triggerRef,
    isOpen: isOpen,
    closeOnOutsideClick: true,
    onClose: () => setIsOpen(false),
    useResponsivePositioning: true,
    verticalOffset: 13,
    focusOnOpen: true,
    focusTargetOnClose: true,
    useAutoCloseOnScroll: true
  }, messagePopoverProps), messagePopoverContent));
};
FormLabelPopover.propTypes = propTypes;
export default FormLabelPopover;